import { Component, inject, input } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideArrowLeft, lucideDot } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';

import { BlocCompétences } from '../croisement-référentiel/models/bloc-compétences';
import { Certification } from '../croisement-référentiel/models/certification';
import { GetIdFichePipe } from '../croisement-référentiel/pipes/get-id-fiche.pipe';
import { StepComponent } from '../shared/components/stepper/step.component';
import { StepperComponent } from '../shared/components/stepper/stepper.component';
import { URL_FRANCE_COMPETENCES_RECHERCHE } from '../shared/models/urls-france-compétences';

@Component({
  selector: 'app-bloc-competences',
  imports: [
    RouterModule,
    HlmButtonImports,
    HlmIconImports,
    NgIcon,
    GetIdFichePipe,
    StepperComponent,
    StepComponent,
    HlmTooltipImports,
  ],
  templateUrl: './bloc-competences.component.html',
  providers: [provideIcons({ lucideArrowLeft, lucideDot })],
})
export class BlocCompetencesComponent {
  readonly #route = inject(ActivatedRoute);
  readonly #router = inject(Router);

  readonly certification = input.required<Certification>();
  readonly bloc = input.required<BlocCompétences>();

  urlFranceCompetencesRecherche = URL_FRANCE_COMPETENCES_RECHERCHE;

  redirect(index: number) {
    switch (index) {
      case 0:
        this.#router.navigate(['.'], { relativeTo: this.#route });
        break;
      case 1:
        this.#router.navigate(['aptitudes'], { relativeTo: this.#route });
        break;
    }
  }
}
